import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// App.tsx
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; // Import Routes and Route
import { AuthProvider, useAuth } from '@/AuthContext'; // Ensure this is the correct path to your AuthContext
import FallBackPage from '@/components/FallBackPage'; // Import your fallback page
import ChatPage from '@/components/ChatPage'; // Import your chat page
import Callback from '@/components/Callback'; // Import your callback component
import { WebSocketContext } from '@/contexts/WebSocketContext'; // Ensure this is the correct path to your WebSocketContext
import { useWebSocket } from '@/hooks/useWebSocket'; // Ensure this is the correct path to your useWebSocket hook
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '@/styles/App.css';
const AppRoutes = () => {
    const { isAuthenticated } = useAuth(); // Get isAuthenticated from context
    return (_jsxs(Routes, { children: [_jsx(Route, { path: "/.auth/login/aad/callback", element: _jsx(Callback, {}) }), _jsx(Route, { path: "/", element: isAuthenticated ? (_jsx(ChatPage, {}) // Render ChatPage if authenticated
                ) : (_jsx(FallBackPage, {}) // Render FallBackPage if not authenticated
                ) })] }));
};
const App = () => {
    const apiKey = process.env.REACT_APP_BACKEND_API_KEY;
    const websocketUrl = `${process.env.REACT_APP_WEBSOCKET_URL}?api_key=${apiKey}` || ''; // Get WebSocket URL from environment variables
    const { ws } = useWebSocket(websocketUrl); // Get the WebSocket instance from the hook
    const [loading, setLoading] = useState(true);
    const { isAuthenticated } = useAuth(); // Get isAuthenticated from context
    useEffect(() => {
        // Set loading to false when user info is available
        if (isAuthenticated !== undefined) {
            setLoading(false);
        }
    }, [isAuthenticated]);
    if (loading) {
        return _jsx("div", { children: "Loading..." }); // Add a loading indicator
    }
    return (_jsx(WebSocketContext.Provider, Object.assign({ value: ws }, { children: _jsxs(Router, { children: [_jsx(AppRoutes, {}), " "] }) })));
};
// Wrap the entire App component with AuthProvider
const Main = () => {
    return (_jsxs(AuthProvider, { children: [_jsx(App, {}), _jsx(ToastContainer, { position: "top-right", newestOnTop: true })] }));
};
export default Main;
